import { PrevNextNav } from "@/ui/prev-next-nav";

import { useInterventionMenuNav } from "./intervention-menu-nav.hook";

const InterventionMenuNav = () => {
  const { previous, next, onSectionItemChange } = useInterventionMenuNav();

  if (!previous || !next) return null;

  return (
    <PrevNextNav
      previous={previous}
      next={next}
      onClick={(item) => onSectionItemChange(item.data)}
    />
  );
};

export default InterventionMenuNav;
